module.exports = "pegasus_template/assets/tech/medium/7.jpg";